module.exports = __webpack_public_path__ + "static/media/onboarding-1.a0aa5135.png";